export type AuthFetch = (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>;

export type AccessTokenProvider = () => string | null | undefined | Promise<string | null | undefined>;

// Wraps window.fetch so every API call carries the current bearer token.
// The token is read on each request, so a silent renewal is picked up by the next call.
// With no token the request still goes out, and the API answers with a 401.
export function createAuthFetch(getAccessToken: AccessTokenProvider): AuthFetch {
  return async function authFetch(input: RequestInfo | URL, init: RequestInit = {}): Promise<Response> {
    const token = await getAccessToken();
    const headers = new Headers(init.headers);

    if (token) headers.set("Authorization", `Bearer ${token}`);

    return window.fetch(input, { ...init, headers });
  };
}
